import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNewIdGrau = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Ebene_1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 485.6 572",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .st1 {\n        fill: #464645;\n      }\n    " }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "st1",
			d: "M415.5,435.6A68.2,68.2 0 1 1 415.5,572A68.2,68.2 0 1 1 415.5,435.6ZM415.5,452.6A51.2,51.2 0 1 0 415.5,555A51.2,51.2 0 1 0 415.5,452.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st1",
			d: "M424.8,513.1v24.2h-18.5v-24.2h-24.4v-18.5h24.4v-24.2h18.5v24.2h24.2v18.5h-24.2Z"
		}),
		/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
			className: "st1",
			d: "M454.8,196h-13.2v-64.7c0-2.5-.8-5-2.6-7L333.3,3.6c-.6-.7-1.4-1.3-2.1-1.8-.2-.2-.5-.3-.7-.4-.7-.4-1.4-.7-2.1-.9-.2,0-.4,0-.6-.2-.8-.2-1.6-.3-2.5-.3H65.4c-11.9,0-21.5,9.6-21.5,21.5v174.6h-13.2c-17,0-30.7,13.8-30.7,30.7v159.8c0,17,13.8,30.7,30.7,30.7h13.2v109.4c0,11.9,9.6,21.5,21.5,21.5h312.7l-19-27.2h0c0,0-293.7,0-293.7,0v-103.6h354.8v24.6h21.5v-24.6h13.2c17,0,30.7-13.8,30.7-30.7v-159.8c0-17-13.8-30.8-30.8-30.8ZM65.4,21.4h249.1v110c0,5.9,4.8,10.8,10.8,10.8h95v53.9H65.4V21.4ZM110.2,351h-15.8l-35.9-55.7v55.7h-17.7v-90.7h15.8l35.9,55.5v-55.5h17.7v90.7ZM191.1,276.1h-42v21.3h35.8v15.8h-35.8v22h42v15.8h-59.7v-90.7h59.7v15.8ZM285.7,351h-14.8l-16.7-55-16.7,55h-14.8l-24.2-90.7h18.5l14,57.2,16.6-57.2h13.2l16.6,57.2,14.1-57.2h18.5l-24.3,90.7ZM368.7,351h-17.7v-90.7h17.7v90.7ZM449.9,337.7c-6.5,9-15,13.2-27.4,13.2h-32.7v-90.7h32.7c12.4,0,20.9,4.2,27.4,13.2,5.6,7.8,5.7,17.1,5.7,32.1s-.1,24.3-5.7,32.1Z"
		}), /* @__PURE__ */ _jsx("path", {
			className: "st1",
			d: "M421,276.1h-13.5v59.1h13.5c6,0,10.3-1.9,13.2-5.6,3.3-3.9,3.7-9.7,3.7-23.9s-.4-20-3.7-23.9c-2.9-3.7-7.3-5.6-13.2-5.6Z"
		})] })
	]
});
export default SvgNewIdGrau;
